// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W3KOb","col":"styles_col__36bdf","actions":"styles_actions__2xFKD","conflict":"styles_conflict__3_I91"};